export const UPDATE_SUBSCRIPTION_BASKET_DELIVERY_POINT_ACTION = 'UPDATE_SUBSCRIPTION_BASKET_DELIVERY_POINT_ACTION';
export const UPDATE_SUBSCRIPTION_BASKET_CUSTOMER_SUBSCRIPTION_ACTION = 'UPDATE_SUBSCRIPTION_BASKET_CUSTOMER_SUBSCRIPTION_ACTION';
export const CONFIRM_SUBSCRIPTION_BASKET_ACTION = 'CONFIRM_SUBSCRIPTION_BASKET_ACTION';
export const PAY_SUBSCRIPTION_BASKET = 'PAY_SUBSCRIPTION_BASKET';
export const FETCH_PRODUCT_SELECTORS_ACTION = 'FETCH_PRODUCT_SELECTORS_ACTION';
export const FETCH_PRODUCT_SELECTORS_V2_ACTION = 'FETCH_PRODUCT_SELECTORS_V2_ACTION';
export const CLEAR_SUBSCRIPTION_BASKET_ACTION = 'CLEAR_SUBSCRIPTION_BASKET_ACTION';
